import { FileType } from "@inrev/common";
import { useRef } from "react";
import { UploadFile } from "../../../types";
import { FileUploadCallbacks } from "./types";

export const useFileUploadCallbacksRef = <
	TFileType extends FileType = FileType,
	T = UploadFile<TFileType>,
>(
	callbacks: FileUploadCallbacks<TFileType, T>,
) => {
	const ref = useRef(callbacks);
	ref.current = callbacks;
	return ref;
};
